<template>
  <div class="tutor-list">
    <el-table ref="multipleTable" :data="tutorList" tooltip-effect="dark" style="width: 100%"
      @expand-change="handleExpandChange">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table ref="multipleTable" :data="props.row.studentData" tooltip-effect="dark"
            style="width: 95%; margin: 0 auto;">
            <el-table-column prop="studentName" label="学生姓名">
            </el-table-column>
            <el-table-column prop="date" label="班级">
              <template slot-scope="scope">
                {{ scope.row.gradeName + scope.row.className }}
              </template>
            </el-table-column>
            <el-table-column prop="sex" label="性别">
            </el-table-column>
            <!-- <el-table-column prop="date" label="年龄">
            </el-table-column> -->
            <el-table-column prop="studentNumber" label="学号">
            </el-table-column>
            <el-table-column label="操作" width="250px">
              <template slot-scope="scope">
                <div class="handle-container">
                  <el-button type="success" size="small"
                    @click="studentEvaluationDetail(scope.row, props.row.teacherId)">学生评分
                  </el-button>
                  <el-button type="success" size="small"
                    @click="studentRecordDetail(scope.row, props.row.teacherId, props.row.teacherName)"
                    v-hasPermi="'sc:studentrecord:query'">详情
                  </el-button>
                  <el-button type="warning" size="small" @click="studentAccredit(scope.row)"
                    v-hasPermi="'sc:student:authorization'">授权
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column label="教师姓名" prop="teacherName">
      </el-table-column>
      <el-table-column label="工号" prop="teacherNumber">
      </el-table-column>
      <el-table-column label="类型" prop="mentorType">
        <template slot-scope="scope">
          <span v-for="(item, index) in scope.row.mentorType.split(',')" :key="index">
            {{mentorTypeList.find(mItem => mItem.dictValue == item.trim()) ? mentorTypeList.find(mItem =>
              mItem.dictValue == item.trim()).dictLabel : ""}}

            <!-- 判断是否为最后一个元素，如果不是则添加“、” -->
            <span v-if="index !== scope.row.mentorType.split(',').length - 1">、</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="已分配学生数" prop="allotmentNum">
      </el-table-column>
      <el-table-column label="操作" width="220px">
        <template slot-scope="scope">
          <div class="handle-container">
            <el-button type="success" size="small" @click="assignStudents(scope.row)"
              v-hasPermi="'sc:student:assignment'">分配学生
            </el-button>
            <el-button type="success" size="small" @click="teacherEvaluation(scope.row)"
              v-hasPermi="'sc:evaluation:tutor'">领导打分
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分配学生 -->
    <assignStudentsDialog v-if="assignStudentsDialogShow" :classSelect="classSelect" :classProps="classProps"
      :classSelectList="classSelectList" :classPlaceholder="classPlaceholder"
      :assignStudentsDialogShow.sync="assignStudentsDialogShow" :assignStudentsData="assignStudentsData"
      :studentList="studentList" @insertTeacherStudentLink="insertTeacherStudentLink"
      @deleteTeacherStudentLink="deleteTeacherStudentLink" @refresh="assignStudents" @search="search"
      @classSearch="classSearch" />
    <!-- 授权学生 -->
    <accreditDialog v-show="accreditDialogShow" :pageInfo.sync="pageInfo" :specialTutorTotal.sync="specialTutorTotal"
      :specialTutorList="specialTutorList" :accreditDialogShow.sync="accreditDialogShow"
      :accreditStudentsData="accreditStudentsData" @currentPageNumChange="currentPageNumChange"
      @handleSizeChange="handleSizeChange" @refreshPageData="refreshPageData" />
    <!-- 领导评价弹窗 -->
    <teacherEvaluationDialog v-if="teacherEvaluationShow" :teacherEvaluationData="teacherEvaluationData"
      :semesterList="semesterList" :teacherEvaluationShow.sync="teacherEvaluationShow" />
    <!-- 学生评价导师详情弹窗 -->
    <studentEvaluationDialog v-if="studentEvaluationShow" :evaluationInfo="evaluationInfo" :semesterList="semesterList"
      :studentEvaluationShow.sync="studentEvaluationShow" />
  </div>
</template>

<script>
import assignStudentsDialog from "../assign-students-dialog/assignStudentsDialog.vue";
import accreditDialog from "../accredit-dialog/accreditDialog.vue";
import teacherEvaluationDialog from "../teacher-evaluation-dialog/teacherEvaluation.vue";
import studentEvaluationDialog from "../student-evaluation-dialog/studentEvaluation.vue";
export default {
  props: ['tutorList', 'mentorTypeList', 'classSelect', 'classProps', 'classSelectList', 'classPlaceholder', 'semesterList'],
  components: {
    assignStudentsDialog,
    accreditDialog,
    teacherEvaluationDialog,
    studentEvaluationDialog
  },
  data() {
    return {
      assignStudentsData: null, // 分配学生导师数据
      assignStudentsDialogShow: false, // 分配学生弹窗显示
      accreditStudentsData: null, // 授权学生数据
      accreditDialogShow: false, // 授权学生弹窗显示
      expandedRow: null, // 当前展开的行，默认为 null
      studentList: [], // 学生列表
      studentName: "",
      specialTutorTotal: 0,
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
      },
      specialTutorList: [],
      gradeId: "",
      classId: "",
      teacherEvaluationShow: false, // 领导评价弹窗
      teacherEvaluationData: null, // 领导评价数据
      studentEvaluationShow: false,
      evaluationInfo: {
        studentData: null,
        teacherId: null
      },
    };
  },
  created() { },
  methods: {
    // 领导评价
    teacherEvaluation(row) {
      this.teacherEvaluationShow = true;
      this.teacherEvaluationData = row;
    },
    refreshPageData() {
      this.pageInfo = {
        pageSize: 10,
        pageNum: 1,
      };
      this.specialTutorTotal = 0;
      this.specialTutorList = [];
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.studentAccredit(this.accreditStudentsData);
    },
    handleSizeChange(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.studentAccredit(this.accreditStudentsData);
    },
    deleteTeacherStudentLink(data) {
      this.delete(this.$url.deleteTeacherStudentLink, data).then(res => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.assignStudents(this.assignStudentsData);
        this.$refs.assignStudentsDialog.dialogOpen();
      }
      )
    },
    insertTeacherStudentLink(data) {
      this.post(this.$url.insertTeacherStudentLink, data).then(res => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success(res.msg);
      }
      )
    },
    // 展开点击
    handleExpandChange(row) {
      this.get(this.$url.selectTeacherStudentLinkByTeacher + "?teacherId=" + row.teacherId).then(res => {
        // console.log(res);
        if (res.code != 200) return this.$message.error(res.msg);
        row.studentData = res.data;
      })
    },
    search(studentName) {
      this.studentName = studentName;
      this.assignStudents(this.assignStudentsData);
    },
    classSearch(gradeId, classId) {
      this.gradeId = gradeId;
      this.classId = classId;
      this.assignStudents(this.assignStudentsData);
    },
    /// 分配学生
    assignStudents(row) {
      this.assignStudentsData = row;

      // 定义一个异步函数来处理数据获取和处理
      async function fetchData() {
        try {
          // 获取已分配的学生信息
          const teacherStudentRes = await this.get(this.$url.selectTeacherStudentLinkByTeacher + "?teacherId=" + row.teacherId);
          if (teacherStudentRes.code !== 200) throw new Error(teacherStudentRes.msg);
          row.studentData = teacherStudentRes.data || [];

          // 获取未分配的学生信息
          const undistributedRes = await this.get(this.$url.selectTeacherStudentLinkUndistributed + "?studentName=" + this.studentName + "&gradeId=" + this.gradeId + "&classId=" + this.classId);
          if (undistributedRes.code !== 200) throw new Error(undistributedRes.msg);

          // 合并两个结果集
          // this.studentList = [...(undistributedRes.data || []), ...(row.studentData || [])];
          this.studentList = undistributedRes.data || [];

          // 显示对话框
          this.assignStudentsDialogShow = true;
        } catch (error) {
          this.$message.error(error.message);
        }
      }

      // 执行异步函数
      fetchData.call(this);
    },
    // 学生授权
    studentAccredit(row) {
      let data = {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
      };
      this.get(this.$url.selectTeacherAllotByTeacher, data).then(res => {
        // console.log(res);
        if (res.code != 200) return this.$message.error(res.msg);
        this.specialTutorList = res.rows;
        this.specialTutorTotal = res.total;
        this.accreditStudentsData = row;
        this.accreditDialogShow = true;
      });
    },
    // 学生评价导师详情
    studentEvaluationDetail(row, teacherId) {
      this.evaluationInfo = {
        studentData: row,
        teacherId: teacherId,
      };
      this.studentEvaluationShow = true;
    },
    // 学生记录详情
    studentRecordDetail(row, teacherId, teacherName) {
      // console.log(row);

      this.$router.push({
        path: "/student-record-detail",
        query: {
          // studentId: row.id,
          // studentName: row.studentName,
          studentInfo: JSON.stringify(row),
          teacherId: teacherId,
          teacherName: teacherName
        },
      });
    },
  },
};
</script>

<style>
@import "./tutorList.scss";
</style>
